import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Container, Row, Col, Image, Button } from 'react-bootstrap';
import './style/Contact.css';

const Contact = () => {
  return (
    <div className="contact">
      <Helmet>
        <title>Contattaci - Studio Vinzaglio 24</title>
        <meta
          name="description"
          content="Contatta lo Studio Vinzaglio 24 per informazioni sui nostri servizi di neuropsicomotricità e prenota un appuntamento a Torino."
        />
        <meta
          property="og:title"
          content="Contattaci - Studio Vinzaglio 24 - Torino"
        />
        <meta
          property="og:description"
          content="Scopri come raggiungere lo Studio Vinzaglio 24 e contattaci per maggiori informazioni sui nostri servizi di neuropsicomotricità a Torino."
        />
        {/* <meta
          property="og:image"
          content="https://www.studiovinzaglio24.com/assets/og-contact.jpg"
        /> */}
        <meta property="og:type" content="website" />
        <meta
          property="og:url"
          content="https://www.studiovinzaglio24.com/contatti"
        />
        <link
          rel="canonical"
          href="https://www.studiovinzaglio24.com/contatti"
        />
      </Helmet>

      <Container>
        <h2 className="contact-title">Contattaci</h2>
        <Row className="align-items-center">
          <Col lg={6} className="contact-map">
            <h3 className="map-title">Dove trovarci</h3>
            <a
              href="https://www.google.com/maps/place/Corso+Vinzaglio,+24,+10121+Torino+TO/@45.0686697,7.6644186,870m/data=!3m1!1e3!4m6!3m5!1s0x47886d1058899223:0x3bf145795503cabe!8m2!3d45.0680414!4d7.6662512!16s%2Fg%2F11bw41l38j?entry=ttu&g_ep=EgoyMDI1MDEwNy4wIKXMDSoASAFQAw%3D%3D"
              target="_blank"
              rel="noopener noreferrer"
            >
              <Image
                src="/assets/map.png"
                alt="Map Location"
                className="map-image"
                fluid
              />
            </a>
          </Col>
          <Col lg={6} className="contact-info">
            <h3>Si riceve solo su appuntamento</h3>
            <p>Riabilitazione neuropsicomotoria a Torino</p>
            <br></br>
            <p>
              <strong>Indirizzo:</strong> Corso Vinzaglio, 24, 10121 Torino TO
            </p>
            <p>
              <strong>Telefono:</strong> +39 011 544 155
            </p>

            <Button
              href="https://www.google.com/maps/place/Corso+Vinzaglio,+24,+10121+Torino+TO/@45.0686697,7.6644186,870m/data=!3m1!1e3!4m6!3m5!1s0x47886d1058899223:0x3bf145795503cabe!8m2!3d45.0680414!4d7.6662512!16s%2Fg%2F11bw41l38j?entry=ttu&g_ep=EgoyMDI1MDEwNy4wIKXMDSoASAFQAw%3D%3D"
              target="_blank"
              rel="noopener noreferrer"
              variant="primary"
              className="contact-button"
            >
              Apri Google Maps
            </Button>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Contact;
